<template>
  <div class="lc lc-small">
    <div class="lc__top">
      <router-link :to="{ name: 'Main' }" class="page__header_title">
        ЭТО<b>ПРОСЧЕТ</b>
      </router-link>
      <div class="lc__name">{{ managerName }}</div>
    </div>

    <div class="goods" v-if="isAdmin">
      <div class="goods__nav">
        <template v-for="item in list">
          <button
            class="btn"
            :class="{ active: activeTab === item.value }"
            type="button"
            :key="item.value"
            @click="activeTab = item.value"
          >
            {{ item.title }}
          </button>
        </template>
      </div>

      <div class="goods__tabs">
        <div
          v-for="item in list"
          :key="item.value"
          class="goods__tabs_item"
          :class="{ active: activeTab === item.value }"
        >
          <h2 class="goods__title text-center">{{ item.title }}</h2>
          <table-editable :name="item.value" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableEditable from "@/components/Table-editable";
export default {
  name: "Goods",
  components: { TableEditable },
  data() {
    return {
      activeTab: "corps",
      list: [
        { value: "corps", title: "Материал корпуса" },
        { value: "facades", title: "Комплект фасадов" },
        { value: "loops", title: "Фурнитура Петли" },
        { value: "boxes", title: "Фурнитура Ящики" },
        { value: "mechanisms", title: "Фурнитура Подъемные механизмы" },
        { value: "tabletop", title: "Столешница" },
        { value: "tabletop_psc", title: "Столешница (ПСЦ)" },
        { value: "wall_panel", title: "Стеновая панель" },
        { value: "wall_panel_psc", title: "Стеновая панель (ПСЦ)" },
        { value: "other_list", title: "Прочее" }
      ]
    };
  },
  computed: {
    managerName() {
      return this.$store.getters.manager.name;
    },
    isAdmin() {
      return this.$store.getters["manager"]?.role === "admin";
    }
  }
};
</script>
